import { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom';
import { variables } from '../Variables/Variable';
import { MetadataContext } from "../Contexts/MetadataContext";


const CategoryCopy = () => {
    const { setDynamicMeta } = useContext(MetadataContext);
    const ID = useParams();
    const [productList, setProductList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [menu, setMenu] = useState([]);
    const [filters, setFilters] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState([]);
    // "/Language/en"
    const getProductList = () => {
        fetch(variables.API_URL + "Content/GetContentsByMenuId/Menu/" + ID.MenuId, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((Response) => {
                if (Response.ok) {
                    return Response.json();
                }
            })
            .then((Result) => {
                setProductList(Result);
                setFilteredList(Result);
                setFilteredList(Result);

            });
    };

    useEffect(() => {
        if (menu?.MenuTitle) {
            setDynamicMeta({
                Title: menu.MetaTitle || `Home Depot | ${menu.MenuTitle}`,
                Description:
                    menu.MetaDescription ||
                    `Explore ${menu.MenuTitle} at Home Dopot. Premium tiles and ceramics for modern homes.`,
                Keywords: menu.MetaKeyword || `${menu.MenuTitle}, tiles, ceramics, sanitary ware`,
                Url: window.location.href,
                Type: "website",
                Image: variables.PHOTO_URL + menu.ImageUrl,
                TwitterCard: "summary_large_image",
            });
        }

        return () => setDynamicMeta(null); // cleanup
    }, [menu]);

    const getFiltersByMenu = () => {
        fetch(variables.API_URL + "Content/GetFiltersByMenu/Menu/" + ID.MenuId, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((Response) => {
                if (Response.ok) {
                    return Response.json();
                }
            })
            .then((Result) => {
                var array = [
                    {
                        filterName: "",
                        filterValues: [],
                    },
                ];
                Result.forEach((filter) => {
                    array.push({
                        filterName: filter.AttributeName,
                        filterValues: filter.AttributeValues,
                    });
                });

                setFilters(array);

            });
    };

    const getMenuDetails = () => {
        fetch(variables.API_URL + "Menu/GetMenuDetails/" + ID.MenuId, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((Response) => {
                if (Response.ok) {
                    return Response.json();
                }
            })
            .then((Result) => {
                setMenu(Result)
            });
    };

    function filterArray(array, filters) {
        const filterKeys = Object.keys(filters);
        return array.filter(item => {
            const filterKeyValue = filterKeys.every(key => {
                if (typeof filters[key] !== 'function') return true;

                var filterArrayId = [];
                selectedFilters.forEach((item) => {
                    filterArrayId.push(parseInt(item.AttributeValue));
                })
                var arrayTrues = [];
                for (var fai = 0; fai < filterArrayId.length; fai++) {
                    var isTrue = false;
                    for (var kdi = 0; kdi < item[key].length; kdi++) {
                        if (filterArrayId[fai] == item[key][kdi].CustomFieldDataId) {
                            isTrue = true;
                            break;
                        }
                    }
                    arrayTrues.push(isTrue);
                }
                return arrayTrues.every(atv => atv === true);
            });
            return filterKeyValue;
        });
    }

    const FilterProduct = async (e, index) => {
        const { name, value } = e.target;
        if (value.length != 0) {
            if (!handleCheck(index)) {
                selectedFilters.push({
                    index: index,
                    AttributeValue: value
                })
            } else {
                handleReplace(selectedFilters, index, value);
            }
        } else {
            if (handleCheck(index)) {
                removeByAttr(selectedFilters, 'index', index, value);
            }
        }
        var array = [];
        selectedFilters.forEach((item) => {
            array.push(parseInt(item.AttributeValue));
        })
        const filters = {

            details: details => details.find(x => {

                return array.includes(x.CustomFieldDataId);
            }),

        };
        const filtered = filterArray(productList, filters);
        setFilteredList(filtered);
    };

    var removeByAttr = function (arr, attr, value) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 2 && arr[i][attr] === value)) {
                arr.splice(i, 1);
            }
        }
        return arr;
    };

    const handleCheck = (val) => {
        var b = selectedFilters.find(a => a.index == val);
        if (b != undefined) {
            return true;
        }
        return false;
    };

    var handleReplace = function (arr, index, value) {
        const b = selectedFilters.findIndex(a => a.index == index);
        if (b != -1) {
            arr[b].AttributeValue = value;
            return arr;
        }
    };

    useEffect(() => {
        getProductList();
        getMenuDetails();
        getFiltersByMenu();
    }, []);

    return (
        <>
            {/* <!--Start Page Header--> */}
            <section className="page-header">
                <div className="page-header__bg" style={{ backgroundImage: `url(${variables.PHOTO_URL + menu.ImageUrl})` }}>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-header__wrapper">
                                <div className="page-header__content">
                                    <h2>{ID.MenuTitle}</h2>
                                    <div className="page-header__menu">
                                        <ul>
                                            <li><a hreflang="en" href="/">Home</a></li>
                                            <li>{ID.MenuTitle}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!--End Page Header--> */}

            <section className="services-two services-two--services-two">
                <div className="container">
                    <div className="sec-title text-center">
                        <p className="sec-title__text">
                            {menu.MetaDescription}
                        </p>
                    </div>

                    <div className='dropdown_filter_main'>
                        {filters.slice(1).map((filter, index) => (
                            <div className='dropdown_filter_inner' key={index}>
                                <select
                                    className='inputBoxSelect'
                                    id={"CustomFieldData" + index}
                                    name={filter.filterName}
                                    onChange={(e) => FilterProduct(e, index)}
                                >
                                    <option className='info' value="">
                                        {filter.filterName}
                                    </option>

                                    {filter.filterValues.map((Attr) => (
                                        <option
                                            key={Attr.AttributeValueId}
                                            className='info'
                                            value={Attr.AttributeValueId}
                                        >
                                            {Attr.AttributeName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        ))}
                    </div>

                </div>

                <div className="row itms-container">
                    {filteredList.map((product) => {
                        return (
                            <div className="col-xl-4 col-lg-4 col-md-6" key={product.ContentId}>
                                <div className="services-two__single wow animated fadeInUp" data-wow-delay="0.1s">
                                    <div className="services-two__single-img">
                                        <a hreflang="en" href={"/" + product.Url}>
                                            <img src={variables.PHOTO_URL + product.ImageUrl} alt={
                                                product.ImageAlt ?? product.ContentTitle
                                            } />
                                        </a>
                                    </div>

                                    <div className="services-two__single-content text-center">
                                        <h2><a hreflang="en" href={"/" + product.Url}>{product.ContentTitle}</a></h2>
                                        <p>
                                            {product.SmallDescription}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </section>
        </>
    );

}
export default CategoryCopy;